export const MAX_FLOOR = 40

export function parseFloor(value: string): number | null {
  const trimmed = value.trim()
  if (!/^-?\d+$/.test(trimmed)) return null
  return Number(trimmed)
}

export function isFloorTooHigh(value: string): boolean {
  const parsed = parseFloor(value)
  return parsed != null && parsed >= MAX_FLOOR
}

export function isNonClimbingFloor(value: string): boolean {
  const parsed = parseFloor(value)
  return parsed != null && parsed <= 0
}

export function floorsToClimbCount(
  floorValue: string,
  hasElevator: boolean | null,
  options?: { bringToTheDoor?: boolean | null; floor1IsGroundLevel?: boolean },
): number {
  if (hasElevator !== false) return 0
  if (options?.bringToTheDoor !== true) return 0
  const parsed = parseFloor(floorValue)
  if (parsed == null || parsed <= 0) return 0
  if (options.floor1IsGroundLevel && parsed === 1) return 0
  return parsed
}
